import { useEffect } from 'react';

interface PageMetaProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  schemaData?: Record<string, unknown> | Record<string, unknown>[];
}

export default function PageMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  schemaData,
}: PageMetaProps) {
  useEffect(() => {
    const defaultTitle = '吃瓜网官网 — 51吃瓜网官网入口与91吃瓜网官网 | 黑料吃瓜网官网每日爆料';
    const defaultDesc = '吃瓜网官网📰首页入口，提供51吃瓜网官网、🎬91吃瓜网官网、黑料吃瓜网官网等最新热门吃瓜爆料内容。每日更新网红塌房、明星黑料、💬博主反差视频等网络热门事件，想吃瓜就来吃瓜网官网。';
    const defaultKeywords = '吃瓜网官网,51吃瓜网官网,91吃瓜网官网,黑料吃瓜网官网,吃瓜网站,51吃瓜在线,吃瓜爆料,网红塌房,黑料视频,在线吃瓜,吃瓜网址,每日吃瓜';

    const finalTitle = title || defaultTitle;
    const finalDesc = description || defaultDesc;
    const finalKeywords = keywords || defaultKeywords;

    document.title = finalTitle;

    const setMeta = (name: string, content: string, propName?: string) => {
      const attr = propName ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', finalDesc);
    setMeta('keywords', finalKeywords);
    if (canonicalUrl) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonicalUrl);
    }
    setMeta('og:title', finalTitle, true);
    setMeta('og:description', finalDesc, true);
    setMeta('og:type', ogType, true);
    if (canonicalUrl) setMeta('og:url', canonicalUrl, true);
    if (ogImage) setMeta('og:image', ogImage, true);
    setMeta('twitter:title', finalTitle);
    setMeta('twitter:description', finalDesc);

    const existingScripts = document.querySelectorAll('script[type="application/ld+json"][data-readdy-schema]');
    existingScripts.forEach((s) => s.remove());

    if (schemaData) {
      const schemas = Array.isArray(schemaData) ? schemaData : [schemaData];
      schemas.forEach((schema) => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-readdy-schema', '');
        script.textContent = JSON.stringify(schema, null, 2);
        document.head.appendChild(script);
      });
    }

    return () => {
      const cleanup = document.querySelectorAll('script[type="application/ld+json"][data-readdy-schema]');
      cleanup.forEach((s) => s.remove());
    };
  }, [title, description, keywords, canonicalUrl, ogType, ogImage, schemaData]);

  return null;
}